
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10038_9200)","stroke":"#1F4053","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M14.32.501H1.65C1.05.471.53.931.5 1.541v8.81c.03.6.55 1.06 1.15 1.04h12.67c.6.03 1.12-.43 1.15-1.04v-8.81c-.03-.61-.55-1.07-1.15-1.04z"}}),_c('path',{attrs:{"d":"M.5 1.938l6.75 4.06c.46.25 1.01.25 1.47 0l6.75-4.06"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10038_9200"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h15.97v11.89H0z"}})])])])
          )
        }
      }
    